import * as React from 'react';
import type { ConnectorFormat } from '../../../../app/ApiGen';
import type { InputComponentProps } from '../../../../design-system';
import { type MenuOption, SelectionMenu } from '../../../SelectionMenu';

const options: MenuOption<ConnectorFormat>[] = [
  { label: 'Cable', value: 'CABLE' },
  { label: 'Socket', value: 'SOCKET' },
];

export const FormatInput: React.FC<InputComponentProps<ConnectorFormat>> = ({
  disabled,
  error,
  helperText,
  onBlur,
  onChange,
  name,
  value,
}) => (
  <SelectionMenu
    aria-label="Format"
    disabled={disabled}
    error={error}
    helperText={helperText}
    name={name}
    onBlur={onBlur}
    onChange={onChange}
    options={options}
    value={value}
  />
);
